import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Core components
import Box from 'components/core/Box';
import Card from 'components/core/Card';
import List from 'components/core/List';
import Typography from 'components/core/Typography';
// Models
import mPartner from 'models/cpm/partner';
// Custom
import { cpmPartnersDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const PartnerInfo = ({ partner }) => {
  const { name, financialInformation } = partner;

  return (
    <Box type="defaultBackground" className="p-3">
      <div className="row information-item-wrapper">
        <div className="col-12 col-lg-6">
          <div className="pt-3">
            <Card
              title={(
                <Typography type="subtitle2">
                  <LocalizedMessage id="title.generalInfo" />
                </Typography>
              )}
              contentOptions={{
                expandable: true,
                expanded: true,
              }}
            >
              <List disablePadding>
                {/* ----- Name ----- */}
                <InformationItem
                  lightMode
                  label={<LocalizedMessage id="field.name" />}
                  icon="partner"
                  value={name}
                />
                {financialInformation && (
                  <React.Fragment>
                    {/* ----- Address ----- */}
                    <InformationItem
                      lightMode
                      label={<LocalizedMessage id="field.address" />}
                      icon="itemAddress"
                      value={mPartner.getAddressDesc(partner)}
                    />
                    {/* ----- Email ----- */}
                    <InformationItem
                      lightMode
                      label={
                        <LocalizedMessage id="field.emailForCommissionInvoices" />
                      }
                      icon="itemEmail"
                      value={financialInformation.emailForCommissionInvoices}
                    />
                  </React.Fragment>
                )}
              </List>
            </Card>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="pt-3">
            <Card
              title={(
                <Typography type="subtitle2">
                  <LocalizedMessage id="title.financialInformation" />
                </Typography>
              )}
              contentOptions={{
                expandable: true,
                expanded: true,
              }}
            >
              <List disablePadding>
                {financialInformation ? (
                  <React.Fragment>
                    {/* ----- Invoice Identifier ----- */}
                    <InformationItem
                      lightMode
                      label={<LocalizedMessage id="field.invoiceIdentifier" />}
                      icon="itemInvoice"
                      value={financialInformation.invoiceIdentifier}
                    />
                    {/* ----- National Identifier ----- */}
                    <InformationItem
                      lightMode
                      label={<LocalizedMessage id="field.nationalIdentifier" />}
                      icon="itemIdentifier"
                      value={financialInformation.nationalIdentifier}
                    />
                    {/* ----- Iban ----- */}
                    <InformationItem
                      lightMode
                      label={<LocalizedMessage id="field.iban" />}
                      icon="itemBank"
                      value={financialInformation.iban}
                    />
                    {/* ----- European Vat Number ----- */}
                    <InformationItem
                      lightMode
                      label={<LocalizedMessage id="field.europeanVatNumber" />}
                      icon="itemVatNumber"
                      value={financialInformation.europeanVatNumber}
                    />
                  </React.Fragment>
                ) : ''}
              </List>
            </Card>
          </div>
        </div>
      </div>
    </Box>
  );
};

PartnerInfo.propTypes = {
  partner: cpmPartnersDataShape.isRequired,
};

module.exports = PartnerInfo;



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/partner/PartnerInfo.js